import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { InfraService } from './infra.service';


@Injectable({
  providedIn: 'root'
})
export class Daiseydashboard {

  private coreAPIUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.coreAPIUrl = data.WebEndPoint2 + 'daiseydashboard';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
    // if (localStorage.getItem('selectedregion') == '1') {
    //   this.coreAPIUrl = environment.coreUrl + 'daiseydashboard';
    // }
    // else {
    //   this.coreAPIUrl = environment.coreRowUrl + 'daiseydashboard';
    // }
  }

  public getDaisedashboardTemplate(engagementId: number, accountCalenderId: number, selectedTemplate: number) {
    return this.http.get(`${this.coreAPIUrl}/GetDaiseyDashboardTemplate/${engagementId}/?accountCalender=${accountCalenderId}&selectedregion=${selectedTemplate}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }
}
